///////////////////////////
import { Component } from '@angular/core';
import { ApiRequestModel } from '../../models/api_request_model';
import { BaseClass } from '../../models/master/mastermodel';
//export interface ICodeTypeValue {
//    Code: number,
//    LongValue: string,
//    ShortValue: string,
//    CodeType: string,
//}

//export class CodeTypeValue implements ICodeTypeValue {
//    constructor(public Code: number, public LongValue: string, public ShortValue: string, public CodeType: string) {
//    }
//}
//login.service.ts

export class CodeTypeValue {
  public Code: number;
  public LongValue: string;
  public ShortValue: string;
  public CodeType: string;
  public ParentValue: string;
  public SeqNo: number;
}

//export class CodeTypeRequest {
//  public CodeType: string;
//  public SendApiRequestModel: ApiRequestModel;
//}
export class CodeTypeRequest extends BaseClass {
  public CodeTypeValueCode: number;
  public CodeType: string;
  public LongValue: string;
  public ShortValue: string;
  public ParentValue: string;
  public SeqNo: number;
}
